import React from "react";
import RecurringSummaryPage from "./RecurringSummaryPage";

/**
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryPage = () => {
    const documentTitle = "Recurring Summary";

    return <RecurringSummaryPage documentTitle={documentTitle} />;
};

export default ConnectedRecurringSummaryPage;
